// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9509 ? "6f31d389" : chunkId) + "." + {"1548":"ab3c094451381f98","8436":"cab94b59cca0a8ff","9509":"a7058bc4468e2c5a"}[chunkId] + ".js";
};